import { compose, withStateHandlers } from "recompose";

export const withModal = ({
  isOpenProp = "isModalOpen",
  toggleProp = "toggleModal",
  setIsOpenProp = "setIsModalOpen",
} = {}) =>
  compose(
    withStateHandlers(
      (props) => ({
        [isOpenProp]: props[isOpenProp] || false,
      }),
      {
        [toggleProp]: (state) => () => ({ [isOpenProp]: !state[isOpenProp] }),
        [setIsOpenProp]: () => (value) => ({ [isOpenProp]: value }),
      }
    )
  );

export default withModal;
